import { concat } from '../../helpers/common'
import {
  ClearCreateAdServerPayload,
  ClearGetAdServerLineItemsPayload,
  ClearGetAdServerListPayload,
  ClearUpdateAdServerPayload,
  CreateAdServerFailurePayload,
  CreateAdServerPayload,
  CreateAdServerSuccessPayload,
  GetAdServerLineItemsFailurePayload,
  GetAdServerLineItemsPayload,
  GetAdServerLineItemsSuccessPayload,
  GetAdServerListFailurePayload,
  GetAdServerListPayload,
  GetAdServerListSuccessPayload,
  UpdateAdServerFailurePayload,
  UpdateAdServerPayload,
  UpdateAdServerSuccessPayload
} from '../types/adServer'

const MODULE_NAME = 'AD_SERVER/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION
export const GET_AD_SERVER_LIST = concat(MODULE_NAME, 'GET_AD_SERVER_LIST')
export const GET_AD_SERVER_LIST_SUCCESS = concat(MODULE_NAME, 'GET_AD_SERVER_LIST_SUCCESS')
export const GET_AD_SERVER_LIST_FAILURE = concat(MODULE_NAME, 'GET_AD_SERVER_LIST_FAILURE')
export const CLEAR_GET_AD_SERVER_LIST = concat(MODULE_NAME, 'CLEAR_GET_AD_SERVER_LIST')

export const CREATE_AD_SERVER = concat(MODULE_NAME, 'CREATE_AD_SERVER')
export const CREATE_AD_SERVER_SUCCESS = concat(MODULE_NAME, 'CREATE_AD_SERVER_SUCCESS')
export const CREATE_AD_SERVER_FAILURE = concat(MODULE_NAME, 'CREATE_AD_SERVER_FAILURE')
export const CLEAR_CREATE_AD_SERVER = concat(MODULE_NAME, 'CLEAR_CREATE_AD_SERVER')

export const UPDATE_AD_SERVER = concat(MODULE_NAME, 'UPDATE_AD_SERVER')
export const UPDATE_AD_SERVER_SUCCESS = concat(MODULE_NAME, 'UPDATE_AD_SERVER_SUCCESS')
export const UPDATE_AD_SERVER_FAILURE = concat(MODULE_NAME, 'UPDATE_AD_SERVER_FAILURE')
export const CLEAR_UPDATE_AD_SERVER = concat(MODULE_NAME, 'CLEAR_UPDATE_AD_SERVER')

export const GET_AD_SERVER_LINE_ITEMS = concat(MODULE_NAME, 'GET_AD_SERVER_LINE_ITEMS')
export const GET_AD_SERVER_LINE_ITEMS_SUCCESS = concat(MODULE_NAME, 'GET_AD_SERVER_LINE_ITEMS_SUCCESS')
export const GET_AD_SERVER_LINE_ITEMS_FAILURE = concat(MODULE_NAME, 'GET_AD_SERVER_LINE_ITEMS_FAILURE')
export const CLEAR_GET_AD_SERVER_LINE_ITEMS = concat(MODULE_NAME, 'CLEAR_GET_AD_SERVER_LINE_ITEMS')

export function getAdServerList(): GetAdServerListPayload {
  return { type: GET_AD_SERVER_LIST }
}

export function getAdServerListSuccess(data: GetAdServerListSuccessPayload['data']): GetAdServerListSuccessPayload {
  return { type: GET_AD_SERVER_LIST_SUCCESS, data }
}

export function getAdServerListFailure(error: object): GetAdServerListFailurePayload {
  return { type: GET_AD_SERVER_LIST_FAILURE, error }
}

export function clearGetAdServerList(): ClearGetAdServerListPayload {
  return { type: CLEAR_GET_AD_SERVER_LIST }
}

export function createAdServer(serverData: CreateAdServerPayload['serverData']): CreateAdServerPayload {
  return { type: CREATE_AD_SERVER, serverData }
}

export function createAdServerSuccess(data: object): CreateAdServerSuccessPayload {
  return { type: CREATE_AD_SERVER_SUCCESS, data }
}

export function createAdServerFailure(error: object): CreateAdServerFailurePayload {
  return { type: CREATE_AD_SERVER_FAILURE, error }
}

export function clearCreateAdServer(): ClearCreateAdServerPayload {
  return { type: CLEAR_CREATE_AD_SERVER }
}

export function updateAdServer(updateAdServerData: UpdateAdServerPayload['updateAdServerData']): UpdateAdServerPayload {
  return { type: UPDATE_AD_SERVER, updateAdServerData }
}

export function updateAdServerSuccess(data: object): UpdateAdServerSuccessPayload {
  return { type: UPDATE_AD_SERVER_SUCCESS, data }
}

export function updateAdServerFailure(error: object): UpdateAdServerFailurePayload {
  return { type: UPDATE_AD_SERVER_FAILURE, error }
}

export function clearUpdateAdServer(): ClearUpdateAdServerPayload {
  return { type: CLEAR_UPDATE_AD_SERVER }
}

export function getAdServerLineItems(params: GetAdServerLineItemsPayload['params']): GetAdServerLineItemsPayload {
  return { type: GET_AD_SERVER_LINE_ITEMS, params }
}

export function getAdServerLineItemsSuccess(data: object[]): GetAdServerLineItemsSuccessPayload {
  return { type: GET_AD_SERVER_LINE_ITEMS_SUCCESS, data }
}

export function getAdServerLineItemsFailure(error: object): GetAdServerLineItemsFailurePayload {
  return { type: GET_AD_SERVER_LINE_ITEMS_FAILURE, error }
}

export function clearGetAdServerLineItems(): ClearGetAdServerLineItemsPayload {
  return { type: CLEAR_GET_AD_SERVER_LINE_ITEMS }
}
